<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Acquiring"
            bc1="App"
            bc2="Add Acquiring"
            bc3="Add"
            path="acquirings"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="name"
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Transaction Type </label>
                          </div>
                          <div class="col-sm-9 ">
                            <div v-for="(item,index) in transactionTypes" :key="index" class="form-check d-inline-flex mt-1 w-25">
                              <input class="form-check-input" type="checkbox" :id="'inlineCheckbox'+index" v-model="item.checked">
                              <label class="form-check-label" :for="'inlineCheckbox'+index">{{item.name}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <PaymentMethodSettings
                          :modelValue.sync="paymentMethodSelectedSettings"
                          ref="payemntSetting"
                      />

                      <div class="col-sm-9 offset-sm-3 d-flex justify-content-end mt-1">
                        <button
                          type="button"
                          class="btn btn-primary "
                          @click="saveData"
                          :disabled="loading"
                        >
                          <span class="d-inline-flex"><Loader :loading="loading" :size="size"></Loader></span>
                          Save Details
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {

  mounted() {
    setTimeout(() => {
      this.getTransactionTypes()
    }, 1000);
  },
  data() {
    return {
      settings:{},
      name: "",
      type: "",
      loading: false,
      size: "10px",
      paymentId: "",
      paymentMethodSelectedSettings: {},
      transactionTypes: [],
      code: '',

    };
  },
  methods: {
    saveData() {
      if (this.paymentMethodSelectedSettings.allFieldsCodes.includes(this.code)) {
        if (this.$refs.payemntSetting.clear) {
          this.settings = null
          this.paymentMethodSelectedSettings.settings = this.settings
          this.loading = true;

          let tempTransactionTypeArray = []
          this.transactionTypes.forEach(eachFeature => {
            if (eachFeature.checked) {
              tempTransactionTypeArray.push(eachFeature.id)
            }
          })
          let requestData = {
            name : this.name,
            paymentMethodId : this.paymentId,
            settings : JSON.stringify({}),
            transactionTypes: JSON.stringify(tempTransactionTypeArray)
          }
          this.makeRequest('post', 'v1/add-aquiring', requestData).then(callResponse => {

            if (!callResponse.error) {
              let code = callResponse.response.data.code;

              if (code == 200) {
                let responseData = callResponse.response.data.data;
                if (!this.isEmpty(responseData)) {
                  let storeData = this.$store.getters.getByKey(
                      "acquiringMain"
                  );
                  if (typeof storeData.firstPageData != "undefined") {
                    storeData.firstPageData.data.unshift(responseData);
                    storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                    if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                      storeData.firstPageData.data.pop();
                    }
                    storeData.key = "acquiringMain";
                    delete storeData.otherPageData;
                    this.$store.dispatch("set", storeData);
                  }
                  this.$router.push({
                    name: "aquirings",
                    // params: { add: true }
                  });
                }

              }
            }
            this.loading = false

          });
          return
        }

        let validPaymentFileds = this.$refs.payemntSetting.validateAllFields()

        validPaymentFileds.validateAll().then(payValid => {
          if (payValid) {
            this.$validator.validateAll().then(valid => {
              if (valid) {
                this.loading = true;
                let tempTransactionTypeArray = []
                this.transactionTypes.forEach(eachFeature => {
                  if (eachFeature.checked) {
                    tempTransactionTypeArray.push(eachFeature.id)
                  }
                })
                let requestData = {
                  name : this.name,
                  paymentMethodId : this.paymentId,
                  settings : JSON.stringify(this.settings),
                  transactionTypes: JSON.stringify(tempTransactionTypeArray)
                }
                this.makeRequest('post', 'v1/add-aquiring', requestData).then(callResponse => {

                  if (!callResponse.error) {
                    let code = callResponse.response.data.code;

                    if (code == 200) {
                      let responseData = callResponse.response.data.data;
                      if (!this.isEmpty(responseData)) {
                        let storeData = this.$store.getters.getByKey(
                            "acquiringMain"
                        );
                        if (typeof storeData.firstPageData != "undefined") {
                          storeData.firstPageData.data.unshift(responseData);
                          storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                          if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                            storeData.firstPageData.data.pop();
                          }
                          storeData.key = "acquiringMain";
                          delete storeData.otherPageData;
                          this.$store.dispatch("set", storeData);
                        }
                        this.$router.push({
                          name: "aquirings",
                          // params: { add: true }
                        });
                      }

                    }
                  }
                  this.loading = false

                });
              }
            });
          }
        })

        return

      }

      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let tempTransactionTypeArray = []
          this.transactionTypes.forEach(eachFeature => {
            if (eachFeature.checked) {
              tempTransactionTypeArray.push(eachFeature.id)
            }
          })
          let requestData = {
            name : this.name,
            paymentMethodId : this.paymentId,
            settings : JSON.stringify(this.settings),
            transactionTypes: JSON.stringify(tempTransactionTypeArray)
          }
          this.makeRequest('post', 'v1/add-aquiring', requestData).then(callResponse => {

            if (!callResponse.error) {
              let code = callResponse.response.data.code;

              if (code == 200) {
                let responseData = callResponse.response.data.data;
                if (!this.isEmpty(responseData)) {
                  let storeData = this.$store.getters.getByKey(
                      "acquiringMain"
                  );
                  if (typeof storeData.firstPageData != "undefined") {
                    storeData.firstPageData.data.unshift(responseData);
                    storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                    if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                      storeData.firstPageData.data.pop();
                    }
                    storeData.key = "acquiringMain";
                    delete storeData.otherPageData;
                    this.$store.dispatch("set", storeData);
                  }
                  this.$router.push({
                    name: "aquirings",
                    // params: { add: true }
                  });
                }

              }
            }
            this.loading = false

          });
        }
      });

    },
    getTransactionTypes() {
      this.makeRequest(
          "post",
          "v1/transaction-types",
          {},
          {},
          false
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let tempTransactionTypes = callResponse.response.data.data
            tempTransactionTypes.forEach(eachType => {
              eachType.checked = false
              this.transactionTypes.push(eachType)
            })
          }
        }
      });
    },


  },
  watch:{
    paymentMethodSelectedSettings(val){
      this.paymentId = val.paymentId
      this.settings = val.settings
      this.code = val.code

    }
  }

};
</script>

